<template>
  <div>
    <sectionTitle>
      {{ $t('chooseLayout.title') }}
      <template v-slot:subtitle>
        {{ $t('chooseLayout.subtitle') }}
        <!--Choosing a layout will automatically preselect the neccessary accessories shown in the next step.-->
        <v-tooltip bottom max-width="300">
          <template v-slot:activator="{ on }">
            <v-icon color="grey lighten-1" v-on="on">mdi-information</v-icon>
          </template>
          <div>
            {{ $t('chooseLayout.description') }}
          </div>
        </v-tooltip>
      </template>
    </sectionTitle>
    <div class="pb-12">
      <v-row>
        <v-col
          v-for="(item, k) in allLayoutsData"
          :key="k"
          cols="6"
          md="4"
          lg="3"
          class="d-flex child-flex px-5 mb-5"
          >
          <div
            class="item"
            :class="itemClass(item)"
          >
            <imgCircle
              @click="toggleItem(item)"
              :item="item"
              data-cy-layout-item
              :src="imgPath(item.img)"
              :imgClass="itemClass(item)"
              :isSelected="isSelected(item)"
            />
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import sectionTitle from '@/components/sectionTitle.vue'
import imgCircle from '@/components/imgCircle.vue'

export default {
  name: 'Layout',
  components: {
    sectionTitle, imgCircle
  },
  computed: {
    ...mapGetters([
      'steps',
      'allLayoutsData',
      'activeStep',
      'disabledLayouts',
      'selectedExtensionsModules',
      'layouts',
      'selectedLayout'
    ])
  },
  methods: {
    toggleItem (item) {
      if (this.isDisabled(item)) {
        return
      }
      this.$store.dispatch('SET_LAYOUT', item.id)
      this.$store.commit('SYNC_DATA')
    },
    isSelected (item) {
      return this.selectedLayout === item.id
    },
    isDisabled (obj) {
      return obj.comingSoon || this.disabledLayouts.includes(obj.id)
    },
    itemClass (obj) {
      let classes = ''
      if (this.isDisabled(obj)) {
        classes += 'disabled'
      }
      return classes
    },
    imgPath: path => require('@/assets/layout/interactive/' + path)
  }
}
</script>
